export const oidcSettings = {
  authority: process.env.VUE_APP_OAUTH_AUTHORITY,
  metadataUrl: process.env.VUE_APP_OAUTH_METADATA,
  client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
  response_type: 'token',
  scope: 'openid email',
  redirect_uri: window.location.origin + '/oidc-callback',

  filterProtocolClaims: true,
  loadUserInfo: true,

  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew-oidc.html',

  post_logout_redirect_uri: window.location.origin + '/logout',
}
